export default __webpack_public_path__ + "static/media/Information_red.a9a16db4.svg";